// Mock Data for Chirosport SA Website
// This will be replaced with actual API calls during backend integration

export const newsData = [
  {
    id: "ff80808197d72d520197e99165d90000",
    date: "2025-06-30",
    title: "FICS June 2025 ENews",
    excerpt: "Dear FICS Members & Friends. We are excited to attach the June 2025 eNews, which is full of the latest in Sports Chiropractic from around the world. With the conclusion of the recent CSIT World Sports Games, and the announcement of the FICS Team to The World Games in Chengdu China, this issue is focused on the friendships built by our passionate community of Sports Chiropractors.",
    content: "Dear FICS Members & Friends\n\nWe are excited to attach the June 2025 eNews, which is full of the latest in Sports Chiropractic from around the world.\n\nWith the conclusion of the recent CSIT World Sports Games, and the announcement of the FICS Team to The World Games in Chengdu China, this issue is focused on the friendships built by our passionate community of Sports Chiropractors.\n\nThis edition highlights the incredible work being done globally and celebrates the connections that make our community strong.",
    attachments: [
      { name: "FICS-2025 JUNE Enews_compressed.pdf", url: "#" }
    ]
  },
  {
    id: "ff8080818e9ef8cb018ebd009055000a",
    date: "2024-03-31",
    title: "FICS March 2024 ENews",
    excerpt: "Meet Our Sports Chiro Family",
    content: "Meet Our Sports Chiro Family\n\nIn this edition, we introduce you to the incredible professionals who make up our global sports chiropractic community. From Olympic Games to local sporting events, our members are making a difference in athletes' lives every day.",
    attachments: [
      { name: "FICS-2024 MARCH Enews.pdf", url: "#" }
    ]
  },
  {
    id: "ff8080818800bef6018cd3483ea600b2",
    date: "2023-12-25",
    title: "FICS December 2023 ENews",
    excerpt: "Learning Together",
    content: "Learning Together\n\nAs we close another year, we reflect on the learning and growth opportunities that brought our community together. This edition showcases educational initiatives, research updates, and professional development opportunities for sports chiropractors worldwide.",
    attachments: [
      { name: "FICS-2023 DECEMBER Enews.pdf", url: "#" }
    ]
  },
  {
    id: "ff8080818800bef6018afe672bd30031",
    date: "2023-10-05",
    title: "FICS September 2023 ENews",
    excerpt: "Stronger Together",
    content: "Stronger Together\n\nUnity and collaboration define our approach to sports chiropractic care. This edition highlights partnerships, team efforts, and the collective strength of our global network of sports chiropractors.",
    attachments: [
      { name: "FICS-2023 SEPTEMBER Enews.pdf", url: "#" }
    ]
  },
  {
    id: "ff8080818800bef6018a3cac4b9f0006",
    date: "2023-06-30",
    title: "FICS June 2023 ENews",
    excerpt: "Coming Together as One",
    content: "Coming Together as One\n\nThis mid-year edition celebrates the unity of our international sports chiropractic community. We explore how collaboration and shared expertise are advancing the field and improving athlete care worldwide.",
    attachments: [
      { name: "FICS-2023 JUNE Enews.pdf", url: "#" }
    ]
  },
  {
    id: "ff8080818800bef6018a3c947cb10004",
    date: "2023-04-03",
    title: "FICS March 2023 ENews",
    excerpt: "A Year of Big Events",
    content: "A Year of Big Events\n\nAs we embark on a year filled with major sporting events, this edition prepares our community for the exciting opportunities ahead. From World Championships to regional competitions, sports chiropractors will play a vital role in athlete care.",
    attachments: [
      { name: "FICS-2023 MARCH Enews.pdf", url: "#" }
    ]
  },
  {
    id: "ff80808186e4d729018773fd0b5800bc",
    date: "2023-04-12",
    title: "ABSA Cape Epic 2023",
    excerpt: "ABSA Cape Epic 2023 Report",
    content: "ABSA Cape Epic 2023 Report\n\nChirosport SA was proud to provide on-site chiropractic care at the ABSA Cape Epic 2023, one of the world's most prestigious mountain bike stage races. Our team of sports chiropractors delivered exceptional care to international athletes throughout this grueling eight-day event in the Western Cape.",
    attachments: [
      { name: "Cape Epic 2023 Report.pdf", url: "#" }
    ]
  },
  {
    id: "ff8080817b1c2ab9017b57c2e2930006",
    date: "2021-08-18",
    title: "Special Offer to Chirosport Members",
    excerpt: "Exclusive 6 Gun Pro offer to Chirosport Members",
    content: "Exclusive 6 Gun Pro offer to Chirosport Members\n\nWe are excited to announce an exclusive partnership offer for Chirosport SA members. This special discount on 6 Gun Pro equipment represents our commitment to providing members with access to cutting-edge therapeutic tools.",
    attachments: []
  },
  {
    id: "ff8080817824b81b0178a70d512f044f",
    date: "2021-04-06",
    title: "FICS Quarterly E-News",
    excerpt: "The FICS quarterly E-News is now out. This edition takes a deeper dive into the upcoming Global Symposium.",
    content: "FICS Quarterly E-News\n\nThe FICS quarterly E-News is now out. This edition takes a deeper dive into the upcoming Global Symposium, featuring insights from leading sports chiropractors and highlighting the latest research in sports chiropractic care.",
    attachments: [
      { name: "FICS Quarterly Enews April 2021.pdf", url: "#" }
    ]
  },
  {
    id: "ff8080817824b81b017844448c690250",
    date: "2021-05-07",
    title: "FICS Symposium: Athlete's Journey",
    excerpt: "FICS is hosting their first ever virtual symposium between 7 - 9 May 2021. The star studded speaker lineup will take you through the athletes journey from injury to peak performance, explaining the sports chiropractors role every step of the way.",
    content: "FICS Symposium: Athlete's Journey\n\nFICS is hosting their first ever virtual symposium between 7 - 9 May 2021. The star studded speaker lineup will take you through the athletes journey from injury to peak performance, explaining the sports chiropractors role every step of the way.\n\nThis groundbreaking event brings together international experts to share their knowledge on injury prevention, rehabilitation protocols, and performance optimization strategies.",
    attachments: [
      { name: "FICS Symposium Full Page Poster.pdf", url: "#" }
    ]
  }
];

export const practitionersData = [
  {
    id: "1",
    fullName: "Dr. Ammaarah Ebrahim",
    initials: "AE",
    practiceName: "Elite Sports Chiropractic",
    contactNumber: "+27 11 234 5678",
    alternateNumber: "+27 82 345 6789",
    address: "123 Main Road, Sandton",
    city: "Johannesburg",
    province: "Gauteng",
    country: "South Africa",
    active: true,
    profileType: "Doctor"
  },
  {
    id: "2",
    fullName: "Dr. Anneme Dyer",
    initials: "AD",
    practiceName: "Cape Sports Wellness",
    contactNumber: "+27 21 456 7890",
    alternateNumber: "",
    address: "45 Beach Road, Sea Point",
    city: "Cape Town",
    province: "Western Cape",
    country: "South Africa",
    active: true,
    profileType: "Doctor"
  },
  {
    id: "3",
    fullName: "Dr. Arline Muller",
    initials: "AM",
    practiceName: "Arline Muller Chiropractic",
    contactNumber: "+27 31 789 0123",
    alternateNumber: "+27 83 456 7890",
    address: "78 Beach Front, Umhlanga",
    city: "Durban",
    province: "KwaZulu-Natal",
    country: "South Africa",
    active: true,
    profileType: "Doctor"
  },
  {
    id: "4",
    fullName: "Dr. Athena Plakotaris",
    initials: "AP",
    practiceName: "Athena Sports Therapy",
    contactNumber: "+27 11 890 1234",
    alternateNumber: "",
    address: "56 Oxford Road, Rosebank",
    city: "Johannesburg",
    province: "Gauteng",
    country: "South Africa",
    active: true,
    profileType: "Doctor"
  },
  {
    id: "5",
    fullName: "Dr. Brett Kavonic",
    initials: "BK",
    practiceName: "Kavonic Chiropractic Centre",
    contactNumber: "+27 21 234 5678",
    alternateNumber: "+27 82 901 2345",
    address: "92 Long Street, City Centre",
    city: "Cape Town",
    province: "Western Cape",
    country: "South Africa",
    active: true,
    profileType: "Doctor"
  },
  {
    id: "6",
    fullName: "Dr. Bernadette Coston",
    initials: "BC",
    practiceName: "Coston Sports Clinic",
    contactNumber: "+27 12 345 6789",
    alternateNumber: "",
    address: "34 Church Street, Arcadia",
    city: "Pretoria",
    province: "Gauteng",
    country: "South Africa",
    active: true,
    profileType: "Doctor"
  },
  {
    id: "7",
    fullName: "Dr. Danella Williams",
    initials: "DW",
    practiceName: "Williams Wellness Centre",
    contactNumber: "+27 41 567 8901",
    alternateNumber: "+27 84 678 9012",
    address: "23 Marine Drive, Summerstrand",
    city: "Port Elizabeth",
    province: "Eastern Cape",
    country: "South Africa",
    active: true,
    profileType: "Doctor"
  },
  {
    id: "8",
    fullName: "Dr. Dinisha Patel",
    initials: "DP",
    practiceName: "Patel Sports Chiropractic",
    contactNumber: "+27 31 678 9012",
    alternateNumber: "",
    address: "67 Florida Road, Morningside",
    city: "Durban",
    province: "KwaZulu-Natal",
    country: "South Africa",
    active: true,
    profileType: "Doctor"
  }
];

export const councilMembers = [
  {
    name: "Dr. James Lowe",
    position: "President",
    image: "/council/James_Lowe.jpg"
  },
  {
    name: "Dr. Kelsi Holz",
    position: "Vice President",
    image: "/council/Kelsi_Holz.jpg"
  },
  {
    name: "Dr Muhammed Yaseen Tagari",
    position: "Secretary",
    image: "/council/Muhammed_Yaseen_Tagari.jpg"
  },
  {
    name: "Dr. Hemant Parbhoo",
    position: "Treasurer",
    image: "/council/Hemant_Parbhoo.jpg"
  },
  {
    name: "Dr Robyn Steyn",
    position: "Council Member",
    image: "/council/Robyn_Steyn.jpg"
  },
  {
    name: "Dr. Justin Henry",
    position: "Council Member",
    image: "/council/Justin_Henry.jpg"
  },
  {
    name: "Dr Steven Smilkstein",
    position: "Council Member",
    image: "/council/Steven_Smilkstein.jpg"
  },
  {
    name: "Dr Matthew Kay",
    position: "Council Member",
    image: "/council/Matthew_Kay.jpg"
  },
  {
    name: "Dr Veronique Sheppard",
    position: "Council Member",
    image: "/council/Veronique_Sheppard.jpg"
  },
  {
    name: "Dr Jan-Frederik Enslin",
    position: "Council Member",
    image: "/council/Jan_Enslin.jpg"
  },
  {
    name: "Dr Lizandi Schoeman",
    position: "Council Member",
    image: "/council/Lizandi_Schoeman.jpg"
  },
  {
    name: "Dr Anneme Dyer",
    position: "Council Member",
    image: "/council/Anneme_Dyer.jpg"
  }
];

export const partnerLogos = [
  {
    name: "FICS - Federation of International Chiropractic Sport",
    image: "/partners/partner-01.png"
  },
  {
    name: "South African Sports Medicine Association",
    image: "/partners/partner-02.png"
  },
  {
    name: "International Sports Medicine Federation",
    image: "/partners/partner-03.png"
  }
];

export const heroImages = [
  "https://images.unsplash.com/photo-1754941622117-97957c5d669b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxzcG9ydHMlMjBjaGlyb3ByYWN0aWN8ZW58MHx8fHwxNzYyODQ5MDQyfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1754941622136-6664a3f50b2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxzcG9ydHMlMjBjaGlyb3ByYWN0aWN8ZW58MHx8fHwxNzYyODQ5MDQyfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1706353399656-210cca727a33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxwaHlzaW90aGVyYXB5fGVufDB8fHx8MTc2Mjg0OTA1NXww&ixlib=rb-4.1.0&q=85"
];

export const southAfricanProvinces = [
  "Gauteng",
  "Western Cape",
  "Eastern Cape",
  "KwaZulu-Natal",
  "Free State",
  "North West",
  "Mpumalanga",
  "Limpopo",
  "Northern Cape"
];

export const citiesByProvince = {
  "Gauteng": ["Johannesburg", "Pretoria", "Sandton", "Rosebank", "Midrand", "Centurion"],
  "Western Cape": ["Cape Town", "Stellenbosch", "Paarl", "George", "Mossel Bay"],
  "Eastern Cape": ["Port Elizabeth", "East London", "Grahamstown", "Mthatha"],
  "KwaZulu-Natal": ["Durban", "Pietermaritzburg", "Richards Bay", "Newcastle"],
  "Free State": ["Bloemfontein", "Welkom", "Bethlehem"],
  "North West": ["Rustenburg", "Potchefstroom", "Klerksdorp", "Mahikeng"],
  "Mpumalanga": ["Nelspruit", "Witbank", "Middelburg", "Secunda"],
  "Limpopo": ["Polokwane", "Tzaneen", "Thohoyandou"],
  "Northern Cape": ["Kimberley", "Upington", "Kuruman"]
};

// Mock API functions that will be replaced with actual API calls
export const mockApi = {
  // News
  getNews: () => Promise.resolve(newsData),
  getNewsById: (id) => Promise.resolve(newsData.find(n => n.id === id)),
  
  // Practitioners
  getPractitioners: (page = 1, perPage = 10) => {
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return Promise.resolve({
      data: practitionersData.slice(start, end),
      total: practitionersData.length,
      page,
      perPage
    });
  },
  getPractitionerById: (id) => Promise.resolve(practitionersData.find(p => p.id === id)),
  
  // Contact form
  submitContact: (data) => {
    console.log("Contact form submission (mock):", data);
    return Promise.resolve({ success: true, message: "Thank you for your message. We will respond shortly." });
  },
  
  // Registration
  register: (data) => {
    console.log("Registration submission (mock):", data);
    return Promise.resolve({ 
      success: true, 
      message: "Registration successful! Your application will be reviewed and you will be notified once approved." 
    });
  },
  
  // Login
  login: (email, password) => {
    console.log("Login attempt (mock):", { email, password });
    // Mock login - always succeed for demo
    return Promise.resolve({ 
      success: true, 
      user: { 
        id: "1", 
        email, 
        fullName: "Dr. John Smith",
        isAdmin: email.includes("admin")
      },
      token: "mock-jwt-token-12345"
    });
  },
  
  // Forgot password
  forgotPassword: (email) => {
    console.log("Forgot password request (mock):", email);
    return Promise.resolve({ 
      success: true, 
      message: "If an account with that email exists, a password reset link has been sent." 
    });
  }
};
